import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { FlowsDisplayGridRowDataFragment, FlowSortOrder, UpstreamFlowsFilteredByFieldQuery, UpstreamFlowsFilteredByFieldQueryVariables, WorkbookUpstreamFlowsQuery, WorkbookUpstreamFlowsQueryVariables , UpstreamFlowsFilteredByFieldDocument , WorkbookUpstreamFlowsDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import {
  FlowsDisplayGrid,
  FlowsDisplayGridRowData,
  getRowDataForFlow,
} from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = WorkbookUpstreamFlowsQueryVariables;
type QueryResults = WorkbookUpstreamFlowsQuery;
type QueryResultListNode = FlowsDisplayGridRowDataFragment;
type GridRowData = FlowsDisplayGridRowData;

type QueryVariablesWithFilter = UpstreamFlowsFilteredByFieldQueryVariables;
type QueryResultsWithFilter = UpstreamFlowsFilteredByFieldQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.workbooks && resultData.workbooks[0] && resultData.workbooks[0].upstreamFlowsConnection;
}

function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter): ConnectionListResult<QueryResultListNode> | null {
  return (
    resultData &&
    resultData.fieldsConnection &&
    resultData.fieldsConnection.nodes &&
    resultData.fieldsConnection.nodes[0] &&
    resultData.fieldsConnection.nodes[0].upstreamFlowsConnection
  );
}


export type WorkbookUpstreamFlowsQueryGridProps = GridSortProps<FlowsValidSortFields> & {
  readonly vizportalUrlId: string;
  readonly filteredFieldId: string | null;
  readonly rowCount: number | null;
};

export function WorkbookUpstreamFlowsQueryGrid(props: WorkbookUpstreamFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyUpstreamFlowsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyUpstreamFilteredFlowsLineageGridMessage();

  return (
    props.filteredFieldId ? (
      // Query with Selected Field as Filter
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={UpstreamFlowsFilteredByFieldDocument}
        partialQueryVariables={{ selectedFieldId: props.filteredFieldId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    ) : (
      // Query without Selection
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={WorkbookUpstreamFlowsDocument}
        partialQueryVariables={{ workbookVizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    )
  )
}
